var RawDERObject = /** @class */ (function () {
    function RawDERObject(data) {
        this.data = data;
    }
    RawDERObject.prototype.toDER = function () {
        return [].slice.call(this.data);
    };
    return RawDERObject;
}());
export { RawDERObject };
